import script from "./SetupPwd.vue?vue&type=script&lang=ts&setup=true"
export * from "./SetupPwd.vue?vue&type=script&lang=ts&setup=true"

import "./SetupPwd.vue?vue&type=style&index=0&id=66cd337c&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Client_OdpJ/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66cd337c"]])

export default __exports__